// Region-aware pricing helpers. Plans/add-ons carry US prices in `price` and local list prices in `regional[region]`.
export const LS_REGION = "m365matrix.region";

export const regionMeta = (dataset, region) => {
  const found = (dataset?.regions || []).find((r) => r.id === region);
  if (!found || region === "us") return { ...(dataset?.pricing || {}), region: "us", label: found?.label || "United States" };
  return { ...found, region: found.id };
};

export const localizePlan = (plan, region) => {
  if (region === "us") return { ...plan, estimated: false };
  const local = plan.regional?.[region];
  if (!local) return { ...plan, price: null, prev: null, estimated: false, priceMissing: !!plan.price };
  return {
    ...plan,
    price: { teams: local.teams, noTeams: local.noTeams },
    prev: local.prev || null,
    estimated: !!local.estimated,
  };
};

export const localizeAddon = (addon, region) => {
  if (region === "us") return { ...addon, estimated: false };
  const local = addon.regional?.[region];
  if (!local) return { ...addon, price: null, estimated: false };
  return { ...addon, price: local.price, estimated: !!local.estimated };
};

export const readRegion = (dataset) => {
  const ids = (dataset?.regions || []).map((r) => r.id);
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get("region");
  if (fromUrl && ids.includes(fromUrl)) {
    window.localStorage.setItem(LS_REGION, fromUrl);
    return fromUrl;
  }
  const stored = window.localStorage.getItem(LS_REGION);
  return stored && ids.includes(stored) ? stored : "us";
};
